<template>
    <ac-modal :title="title" :size-class="'modal-lg'" ref="modal">
        <template v-if="widgetReady">
            <div class="row">
                <div class="col-md-2 col-sm-4">
                    <label v-if="isGroupInvoice || isPEGroupInvoice" class="header">Group:</label>
                    <label v-else class="header">Member:</label>
                </div>
                <div class="col-md-4 col-sm-8">
                    <label v-if="isGroupInvoice || isPEGroupInvoice">{{ this.invoice.companyName }}</label>
                    <label v-else>{{ this.invoice.memberName }}</label>
                </div>
                <div class="col-md-2 col-sm-4 verticalLine">
                    <label class="header">Created Date:</label>
                </div>
                <div class="col-md-4 col-sm-8">
                    <label>{{ this.invoice.createdDate | shortDate }}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 col-sm-4">
                    <label v-if="isGroupInvoice || isPEGroupInvoice" class="header">Address:</label>  
                    <label v-else class="header">Dependent of:</label>  
                </div>            
                <div class="col-md-4 col-sm-8">
                    <label v-if="isGroupInvoice || isPEGroupInvoice">{{ this.invoice.companyAddressPt1 }}</label>
                    <label v-if="isGroupInvoice || isPEGroupInvoice" class="visible-sm visible-xs">{{ this.invoice.companyAddressPt2 }}</label>
                    <label v-else>{{ this.invoice.dependentOf }}</label>
                </div>
                <div class="col-md-2 col-sm-4 verticalLine">
                    <label class="header">Created By:</label>
                </div>            
                <div class="col-md-4 col-sm-8">
                    <label>{{ this.invoice.providerName }}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 col-sm-4">
                    <label v-if="!isGroupInvoice && !isPEGroupInvoice" class="header">Group:</label>
                </div>
                <div class="col-md-4 col-sm-8">
                    <label v-if="isGroupInvoice || isPEGroupInvoice" class="hidden-sm hidden-xs">{{this.invoice.companyAddressPt2}}</label>
                    <label v-else>{{ this.invoice.companyName }}</label>
                </div>                
                <div class="col-md-2 col-sm-4 verticalLine">
                    <label class="header">
                        Paid:
                    </label>
                </div>            
                <div class="col-md-4 col-sm-8">
                    <label>{{ hasBeenPaid ? 'Yes' : 'No'}}</label>
                </div>
            </div>
            <div class="row" v-if="hasBeenPaid">
                <div class="col-md-6 col-sm-0"></div>
                <div class="col-md-2 col-sm-4">
                    <label class="header">
                        Payment Date: 
                    </label>
                </div>
                <div class="col-md-3 col-sm-8">
                    <label>{{ this.invoice.paymentDate | shortDate }}</label>
                </div>
            </div>
            <br>
            <hr>
            <div v-if="hasCustomNotes" class="row alert alert-warning">
                <div class="col-md-12">
                    <h4>{{this.invoice.customNotes}}</h4>
                </div>
            </div>  
            <hr>
            <table class="table" v-if="consumerId != null">
                <thead>
                    <tr>
                        <th>Item Id</th>
                        <th>Item</th>
                        <th style="max-width: 500px;">Description</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="li in this.lineItems">
                        <td>{{ li.lineItemId }}</td>
                        <td>{{ li.title }}</td>
                        <td style="max-width: 500px; overflow:auto;">{{ li.description }}</td>
                        <td>{{ li.amount | currency}}</td>
                    </tr>
                </tbody>
            </table>
            <table class="table" v-if="consumerId == null && (!hasCustomNotes || isPEGroupInvoice)">
                <thead>
                    <tr>
                        <th>Line Item Id</th>
                        <th>Item</th>
                        <th style="max-width: 550px;">Description</th>
                        <th>Quantity</th>                        
                        <th>Price</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="li in this.lineItems">
                        <td>{{ li.lineItemId }}</td>
                        <td>{{ li.title }}</td>
                        <td style="max-width: 500px; overflow:auto;">{{ li.description }}</td>
                        <td>{{ li.quantity }}</td>
                        <td>{{ li.amount | currency}}</td>
                        <td>{{ li.total | currency }} </td>
                    </tr>
                </tbody>
            </table>
            <div class="row">
                <div class="col-md-12 grandTotal">
                    Total: {{ this.invoice.totalAmount | currency }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" style="text-align: right;">
                    <ac-button class="btn-sm btn-red wl-btn-failure button-size" :action="closeModal">
                        CLOSE
                    </ac-button>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "@/global/framework/api.js";

    export default {
        name: "InvoiceDetailsModal",
        data() {
            return {
                widgetReady: false,
                consumerId: null,
                companyId: null,
                invoice: null,
                entityTypeId: null,
                lineItems: []
            }
        },
        computed: {
            title() {
                return this.widgetReady ? `Invoice #${this.invoice.invoiceId}` : '';
            },
            isPEGroupInvoice() { return this.entityTypeId == 4 && this.companyId == null; },
            isGroupInvoice() { return this.companyId != null; },
            hasCustomNotes() { return this.invoice.customNotes != null;},
            hasBeenPaid() { return this.invoice.paid === 'Yes' || this.invoice.payment === 'Paid'; }
        },
        methods: {
            async showModal({invoice, consumerId, companyId, entityTypeId}) {
                this.widgetReady = false;
                this.invoice = invoice;
                this.entityTypeId = entityTypeId;
                if (companyId != null) {
                    this.companyId = companyId;
                }
                if(consumerId != null){
                    this.lineItems = await api.getDataWithTwoIds('Consumer', consumerId, 'GetLineItemsByInvoice', invoice.invoiceId);
                    this.consumerId = consumerId;
                }
                else {
                    this.lineItems = await api.getDataWithTwoIds("Invoice", invoice.invoiceId, "GetLineItemsByInvoiceVM", invoice.providerEntityId);
                }
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            closeModal() {
                this.$refs.modal.close();
            }
        }
    }
</script>

<style scoped>
hr{
    margin: initial;
    opacity: 1;
}
label{
    padding-left: 20px;
}
th, .header{
    font-weight: bold !important;
}
.grandTotal{
    text-align:right;
    padding-right:100px;
    font-size: large;
    font-weight: bold;
}
.verticalLine {
  border-left: thin solid lightgray;
}
</style>